const handleContactDrawer = () => {
  const contactDrawer = document.getElementById("contact-drawer");

  if (contactDrawer) {
    if (window.location.hash === "#contact-drawer") {
      contactDrawer.setAttribute("open", "");
    } else {
      contactDrawer.removeAttribute("open");
    }
  }
};

const handleContactDrawerClick = (event) => {
  if (
    event.target.matches(
      'a[href="#contact-drawer"], a[href="#contact-drawer"] *'
    )
  ) {
    const contactDrawer = document.getElementById("contact-drawer");
    if (contactDrawer) {
      contactDrawer.setAttribute("open", "");
    }
  }
};

window.addEventListener("DOMContentLoaded", handleContactDrawer);
window.addEventListener("hashchange", handleContactDrawer);
document.addEventListener("click", handleContactDrawerClick);
